import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconForecast = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={35}
    height={33}
    fill="none"
    viewBox="0 0 35 33"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-forecast_svg__a)">
      <path
        fill="url(#icon-forecast_svg__b)"
        d="M22.5 18.5c.188 0 .375.156.438.375a.492.492 0 0 1-.157.531l-4 3.5a.602.602 0 0 1-.312.094.503.503 0 0 1-.282-.094.534.534 0 0 1-.156-.625L19.22 19.5H17.5a.508.508 0 0 1-.469-.344.434.434 0 0 1 .125-.531l4-3.5c.188-.125.438-.156.625 0a.48.48 0 0 1 .157.594L20.75 18.5h1.75Zm-9.625-3.375c.094.094.188.188.313.281A3.27 3.27 0 0 0 13 16.531v.219l-1.844.594a.385.385 0 0 1-.5-.5l.781-2.344-2.218-1.125a.393.393 0 0 1 0-.719l2.219-1.125-.782-2.344a.385.385 0 0 1 .5-.5l2.344.782 1.125-2.219a.393.393 0 0 1 .719 0l1.125 2.219 2.343-.813c.313-.094.625.219.5.531l-.28.844S19 10 18.968 10c-.782 0-1.532.25-2.157.656-1.156-.906-2.875-.844-3.937.219-1.188 1.188-1.188 3.094 0 4.25Zm12.063-1.063c1.156.22 2.062 1.22 2.062 2.438 0 1.406-1.125 2.5-2.5 2.5h-.531a1.486 1.486 0 0 0-1.5-1.469h-.25l.625-1.437a1.462 1.462 0 0 0-.5-1.782 1.494 1.494 0 0 0-.875-.312c-.344 0-.688.156-.969.375l-4 3.5c-.313.281-.5.688-.5 1.094-1.156-.219-2-1.25-2-2.469 0-1.188.844-2.219 2-2.438V14a3 3 0 0 1 3-3c1 0 1.875.5 2.406 1.25.344-.156.688-.25 1.094-.25 1.219 0 2.219.906 2.438 2.063Zm-9.907-.75a4.236 4.236 0 0 0-1.406 1.157A2.012 2.012 0 0 1 12.969 13c0-1.125.875-2 2-2 .406 0 .75.125 1.062.313-.5.562-.843 1.25-1 2Z"
      />
    </g>
    <defs>
      <linearGradient
        id="icon-forecast_svg__b"
        x1={28}
        x2={12.39}
        y1={7}
        y2={26.512}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
      <filter
        id="icon-forecast_svg__a"
        width={34.094}
        height={32.063}
        x={0.906}
        y={0.938}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2206_48379"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_2206_48379"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_2206_48379"
          result="effect2_dropShadow_2206_48379"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_2206_48379"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconForecast;
